export type LegalSection = {
  heading: string;
  paragraphs: string[];
};
export type LegalDocument = {
  slug: string;
  title: string;
  footerLabel: string;
  /** Si el titular ya tiene este documento publicado, indica aquí su URL y el pie enlazará directamente a ella. */
  externalUrl?: string;
  pendingNotice?: string;
  showCookieSettings?: boolean;
  sections: LegalSection[];
};

export const SUPPORT_EMAIL = 'soporte.int@naturiasalud.com';

export const legalDocuments: LegalDocument[] = [{
  slug: 'aviso-legal',
  title: 'Aviso legal e identificación del vendedor',
  footerLabel: 'Aviso legal',
  pendingNotice: 'Documento pendiente de completar por el titular con su nombre o razón social, NIF, domicilio y, en su caso, datos registrales.',
  sections: [{
    heading: 'Titular del sitio web',
    paragraphs: ['Nombre o razón social: pendiente de completar.', 'NIF: pendiente de completar.', 'Domicilio: pendiente de completar.']
  }, {
    heading: 'Contacto',
    paragraphs: [`Correo electrónico: ${SUPPORT_EMAIL}`]
  }, {
    heading: 'Objeto',
    paragraphs: ['Este sitio web presenta y comercializa el Megapack Salud Plena de Naturia, un producto digital de contenido educativo en formato PDF.']
  }]
}, {
  slug: 'condiciones',
  title: 'Condiciones de compra',
  footerLabel: 'Condiciones de compra',
  pendingNotice: 'Documento pendiente de completar por el titular con los datos del vendedor, los impuestos aplicables y el procedimiento de reclamaciones.',
  sections: [{
    heading: 'Producto',
    paragraphs: ['Megapack Salud Plena: 6 tomos principales y 5 bonos en formato PDF. Es un producto digital: no se envían libros ni materiales físicos.', 'Se trata de contenido educativo. No sustituye el diagnóstico, tratamiento ni asesoramiento de un profesional sanitario.']
  }, {
    heading: 'Precio y pago',
    paragraphs: ['Megapack completo: 23,99 €, pago único. No hay suscripciones ni cargos recurrentes.', 'El pago se realiza en una plataforma de pago externa. Antes de confirmar la compra, comprueba el importe final que se muestra en la página de pago.']
  }, {
    heading: 'Entrega',
    paragraphs: ['Tras confirmar el pago, recibirás por correo electrónico el acceso para descargar los archivos.']
  }, {
    heading: 'Licencia de uso',
    paragraphs: ['La compra otorga una licencia personal e intransferible. Puedes imprimir los archivos para tu uso personal, pero no está permitido compartirlos ni revenderlos.']
  }, {
    heading: 'Garantía y reembolsos',
    paragraphs: ['Consulta la política de desistimiento y reembolsos.']
  }]
}, {
  slug: 'privacidad',
  title: 'Política de privacidad',
  footerLabel: 'Privacidad',
  pendingNotice: 'Documento pendiente de completar por el titular con la identidad y los datos de contacto del responsable del tratamiento, las bases legales y los plazos de conservación.',
  sections: [{
    heading: 'Responsable del tratamiento',
    paragraphs: ['Pendiente de completar.', `Contacto: ${SUPPORT_EMAIL}`]
  }, {
    heading: 'Datos que se tratan en esta página',
    paragraphs: ['Esta página no incluye formularios de registro. Los datos necesarios para la compra se facilitan en la plataforma de pago externa, que los trata conforme a su propia política de privacidad.', 'Si nos escribes por correo electrónico, trataremos los datos que nos facilites para responder a tu consulta.']
  }, {
    heading: 'Cookies y publicidad',
    paragraphs: ['Solo si das tu consentimiento se activa Meta Pixel, una herramienta de Meta Platforms Ireland Ltd. para medir la eficacia de nuestros anuncios. Consulta la política de cookies para más información.']
  }, {
    heading: 'Tus derechos',
    paragraphs: [`Puedes ejercer tus derechos de acceso, rectificación, supresión, oposición, limitación del tratamiento y portabilidad escribiendo a ${SUPPORT_EMAIL}.`, 'También puedes presentar una reclamación ante la Agencia Española de Protección de Datos (www.aepd.es).']
  }]
}, {
  slug: 'cookies',
  title: 'Política de cookies',
  footerLabel: 'Cookies',
  showCookieSettings: true,
  sections: [{
    heading: 'Qué usamos',
    paragraphs: ['Almacenamiento técnico (necesario): guardamos en tu navegador tu elección sobre cookies para no volver a preguntarte en cada visita. Se conserva hasta que borres los datos del navegador o cambies tu elección.', 'Meta Pixel (publicidad, opcional): herramienta de Meta Platforms Ireland Ltd. que mide visitas y conversiones de nuestros anuncios en Facebook e Instagram. Puede instalar cookies como «_fbp». Solo se carga si la aceptas.']
  }, {
    heading: 'Cómo se aplica tu elección',
    paragraphs: ['Mientras no aceptes las cookies de publicidad, Meta Pixel no se carga ni envía información.', 'Si retiras tu consentimiento, dejamos de enviar datos a Meta e intentamos eliminar sus cookies de este dominio. También puedes borrarlas desde la configuración de tu navegador.']
  }, {
    heading: 'Cambiar tu elección',
    paragraphs: ['Puedes aceptar, rechazar o configurar las cookies en cualquier momento desde el botón de abajo o desde el enlace «Configurar cookies» al pie de la página.']
  }]
}, {
  slug: 'desistimiento',
  title: 'Desistimiento y reembolsos',
  footerLabel: 'Desistimiento y reembolsos',
  pendingNotice: 'Documento pendiente de completar por el titular con las condiciones del derecho de desistimiento aplicables a contenidos digitales y los datos del vendedor.',
  sections: [{
    heading: 'Garantía de 7 días',
    paragraphs: [`Si en los 7 días siguientes a tu compra el material no es lo que esperabas, escríbenos a ${SUPPORT_EMAIL} indicando el correo electrónico con el que compraste y te devolveremos el importe.`]
  }, {
    heading: 'Derecho de desistimiento',
    paragraphs: ['Pendiente de completar por el titular conforme a la normativa de consumo aplicable.']
  }, {
    heading: 'Contacto',
    paragraphs: [`Correo electrónico: ${SUPPORT_EMAIL}`]
  }]
}];
